<template>
  <card>
    <b-row>
      <b-col cols="12">
        <b-form class="row" v-on:submit.prevent="doFilter">
          <b-col md="3">
            <fg-input>
              <div class="form-group input-typeahead">
                <typeahead ref="userProfileUuidTypeahead" customQueryParamName="name" :labelFields="['name']" placeholder="Cari Customer" :urlSearch="apiUrlCustomer" arr-response="data" :model="tableFilter.customer" />
              </div>
            </fg-input>
          </b-col>
          <b-col md="3">
            <el-input class="input-primary" placeholder="Filter dengan kode" clearable v-model="tableFilter.kode"/>
          </b-col>
          <b-col md="2">
            <el-select size="large" clearable v-model="tableFilter.status" placeholder="Filter dengan status">
              <el-option :value="null" label="Semua Status">
              </el-option>
              <el-option :value="0" label="Pending">
              </el-option>
              <el-option :value="1" label="Lunas">
              </el-option>
              <el-option :value="2" label="Tahan">
              </el-option>
            </el-select>
          </b-col>
          <b-col md="3">
            <el-date-picker
              v-model="tableFilter.date"
              type="daterange"
              placeholder="Pick a range">
            </el-date-picker>
          </b-col>
          <b-col md="1">
            <button type="submit" class="btn btn-primary"><font-awesome-icon icon="search"/></button>
          </b-col>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12 text-right">
        <b-button size="md" variant="primary" @click="doExportToExcel">
          <font-awesome-icon icon="download"></font-awesome-icon> Export To Excel
        </b-button>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :can-delete="false" :can-print="true" :can-edit="false" :param-no-uuid="true" :no-actions="true"  :active-url="apiUrl" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['is_active','kode','status',  'start_date', 'end_date', 'customer_id']">
      <template slot="content_created_by" slot-scope="defaultSlotScope">
        <a :href="'#/users/' + defaultSlotScope.rowData.created_by.id">{{defaultSlotScope.rowData.created_by.name}}</a>
      </template>
      <template slot="content_status" slot-scope="defaultSlotScope">
        <b-badge :variant="getStatusColor(defaultSlotScope.rowData.status)">{{getStatus(defaultSlotScope.rowData.status)}}</b-badge>
      </template>
      <template slot="content_customer" slot-scope="defaultSlotScope">
        <a :href="'#/pengaturan/customer/' + defaultSlotScope.rowData.customer.id">{{defaultSlotScope.rowData.customer.name}}</a>
      </template>
      <template slot="content_last_updated_by" slot-scope="defaultSlotScope">
        <a :href="'#/users/' + defaultSlotScope.rowData.last_updated_by.id">{{defaultSlotScope.rowData.last_updated_by.name}}</a>
      </template>
      <template slot="content_total" slot-scope="defaultSlotScope">
        {{formatNumber(defaultSlotScope.rowData.total)}}
      </template>
      <template slot="content_profit" slot-scope="defaultSlotScope">
        {{formatNumber(defaultSlotScope.rowData.profit)}}
      </template>
      <template slot="content_actions" slot-scope="defaultSlotScope">
        <div class="text-center">
          <b-button variant="warning" size="sm" @click="doPrintStruct(defaultSlotScope.rowData.id)" class="mb-0 text-center detail mr-1"><i class="fas fa-print"></i></b-button>
          <b-button variant="info" size="sm" :href="'#/penjualan/' + defaultSlotScope.rowData.id" class="mb-0 text-center detail mr-1" target="_blank"><i class="fas fa-info"></i></b-button>
        </div>
      </template>
      <!-- <template slot="content_actions" slot-scope="defaultSlotScope">
        <div class="text-center">
          <b-button variant="info" size="sm" :href="'#/penjualan/' + defaultSlotScope.rowData.id" class="mb-0 text-center detail mr-1"><i class="fas fa-info"></i></b-button>
          <b-button v-if="defaultSlotScope.rowData.status === 2" variant="primary" size="sm" :href="'#/penjualan/' + defaultSlotScope.rowData.id + '/edit'" class="mb-0 text-center edit"><i class="fas fa-pencil-alt"></i></b-button>
        </div>
      </template> -->
    </paginated-table>
  </card>
</template>
<script>
  import { Input, Checkbox, DatePicker, Select, Option } from 'element-ui'
  import PaginatedTable from '@/components/Tables/PaginatedTableWithResource'
  import CreateNewData from '@/components/Buttons/CreateNewData'
  import Typeahead from '@/components/Typeahead'

  export default {
    components: {
      [Input.name]: Input,
      PaginatedTable,
      Typeahead,
      CreateNewData,
      [DatePicker.name]: DatePicker,
      [Option.name]: Option,
      [Select.name]: Select,
      elCheckbox: Checkbox
    },
    data () {
      return {
        dataKey: 'order-report',
        apiUrl: window.AppConfig.apiUrl + 'order-report',
        apiUrlCustomer: window.AppConfig.apiUrl + 'customer',
        columns: [
          {
            prop: 'code',
            label: 'Kode'
          },
          {
            prop: 'customer',
            label: 'Pelanggan'
          },
          {
            prop: 'total',
            label: 'Total',
            class: 'text-right',
            sortable: true
          },
          {
            prop: 'profit',
            label: 'Profit',
            class: 'text-right',
            sortable: true
          },
          {
            prop: 'status',
            label: 'Status',
            sortable: true
          },
          {
            prop: 'created_by',
            label: 'Dibuat Oleh'
          },
          {
            prop: 'last_updated_by',
            label: 'Diperbarui Oleh'
          },
          {
            prop: 'created_at',
            label: 'Tgl Terbit'
          },
          {
            prop: 'actions',
            label: ''
          }
        ],
        fakeTableFilter: {
          is_active: !!this.$route.query.is_active
        },
        tableFilter: {
          customer: {
            value: null
          },
          is_active: this.$route.query.is_active,
          customer_id: this.$route.query.customer_id,
          kode: this.$route.query.kode,
          status: this.$route.query.status,
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          date: null
        }
      }
    },
    watch: {
      'fakeTableFilter.is_active' (value) {
        this.tableFilter.is_active = value ? 1 : null
        this.doFilter()
      }
    },
    methods: {
      doFilter () {
        this.tableFilter.customer_id = this.tableFilter.customer.value !== null ? this.tableFilter.customer.value : null
        this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
        this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      doExportToExcel () {
        let url = window.AppConfig.webUrl + 'export-report-excel?token=' + this.$store.getters['account/tokens'].access_token
        if (this.tableFilter.customer_id !== null && this.tableFilter.customer_id !== undefined) {
          url += '&customer_id=' + this.tableFilter.customer_id
        }
        if (this.tableFilter.kode !== null && this.tableFilter.kode !== undefined) {
          url += '&kode=' + this.tableFilter.kode
        }
        if (this.tableFilter.status !== null && this.tableFilter.status !== undefined) {
          url += '&status=' + this.tableFilter.status
        }
        if (this.tableFilter.date !== null && this.tableFilter.date.length > 0) {
          url += '&start_date=' + this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') + '&end_date=' + this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
        }
        window.open(url)
      },
      getColorStatus (status) {
        if (status === 'Canceled') {
          return 'dark'
        } else if (status === 'Paid') {
          return 'success'
        } else if (status === 'Invoice') {
          return 'primary'
        } else if (status === 'Working') {
          return 'warning'
        } else if (status === 'New') {
          return 'info'
        } else {
          return 'danger'
        }
      },
      getStatus (value) {
        switch (value) {
          case 0:
            return 'Pending'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'Lunas'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'Tahan'
            // eslint-disable-next-line no-unreachable
            break
          case 3:
            return 'Batal'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusColor (value) {
        switch (value) {
          case 0:
            return 'warning'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'secondary'
            // eslint-disable-next-line no-unreachable
            break
          case 3:
            return 'danger'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getDate (value) {
        return this.$moment(value).format('DD-MM-YYYY')
      },
      doPrintStruct (id) {
        this.$swal({
          title: 'cetak dengan harga shipping?',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
          confirmButtonClass: 'btn btn-success mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            window.open(window.AppConfig.webUrl + 'ipdf/po/' + id + '?with_shipping=1')
          } else {
            window.open(window.AppConfig.webUrl + 'ipdf/po/' + id)
          }
        })
      },
      formatNumber (num) {
        return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
      }
    },
    mounted () {
      // this.initData().requestCategory()
    }
  }
</script>
<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Reports/Index.vue